<h1 mat-dialog-title>{{data.title|translate}}</h1>
<div mat-dialog-content>
    <p>{{data.message|translate}}</p>
</div>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>{{'cancel'|translate}}</button>
    <button mat-button [color]="data.color ? data.color : 'primary'" [mat-dialog-close]="true" cdkFocusInitial>{{'yes'|translate}}</button>
</mat-dialog-actions>
